import React from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { LatLngFormatPreferenceProvider } from '../LatLngFormatPreferenceProvider';
import { useSubscription } from '@meraki-internal/state';
import { SwapIcon } from '../../components/icons/Icons';
import { RoundButton } from '../../components/button/RoundButton';

export const ToggleLatLngFormatPreferenceButton: React.FC<{trackingFrom: string}> = ({ trackingFrom }) => {
    const latLngFormatProvider = useInstance(LatLngFormatPreferenceProvider);
    useSubscription(() => latLngFormatProvider);

    return (
        <RoundButton
            onClick={e => {
                e.stopPropagation();
                latLngFormatProvider.toggle({ trackingFrom });
            }}
            fill="clear"
            size="small"
            data-id="lat-lng-preference"
        >
            <SwapIcon color="medium" size="medium" />
        </RoundButton>
    );
};
